export default __webpack_public_path__ + "static/media/oc-img-1.a742f043.jpg";